import React from "react";
import { object, bool, func, string } from "prop-types";
import { Modal, Row, Col, Button } from "react-bootstrap";
import { SI_MERCH_MESSAGE } from "utils/helperConstants";
import { handleScheduleVIDemo } from "./helperFunctions";
import { MERCH_MODAL_LIBRARY } from "./helperConstants";
import FeatureOverview from "./FeatureOverview";

const VideoInterviewMerchandizingModal = ({
  showModal,
  handleCloseVIMerchandizingModal,
  utmParams,
  isFreeTrial,
  rep,
  interviewType = "videoInterview",
}) => {
  const { labelName, headerImg, iconImg, featureOverview } =
    MERCH_MODAL_LIBRARY[interviewType];

  let trackingSource = "";
  if (interviewType === "videoInterview") {
    trackingSource = "vi-merch-modal";
  } else if (interviewType === "liveInterview") {
    trackingSource = "li-merch-modal";
  }

  return (
    <Modal
      className="VI-merchandizing-modal"
      show={showModal}
      onHide={handleCloseVIMerchandizingModal}
    >
      <Modal.Body className="p-4">
        <Row className="mb-4">
          <Col style={{ position: "relative" }}>
            <img
              src={headerImg}
              alt={`${labelName.toLowerCase()} call`}
              height="100%"
              width="100%"
              style={{
                maxHeight: "300px",
                maxWidth: "650px",
              }}
            />
            <Button
              size="sm"
              variant="default"
              className="btn-close-x"
              onClick={handleCloseVIMerchandizingModal}
              id="closeVIMerchandizingModalHeader"
              style={{ position: "absolute", right: "27px" }}
            >
              <span style={{ fontSize: "24px", color: "black" }}>&times;</span>
            </Button>
          </Col>
        </Row>
        <Row>
          <Col>
            <div className="d-flex align-items-center mb-1">
              <img src={iconImg} alt="assessment icon" />
              <div className="SI-badge evaluation-badge mt-0 ml-2 text-center">
                {labelName}
              </div>
            </div>
            <p className="mb-0" style={{ fontSize: "16px" }}>
              {SI_MERCH_MESSAGE[interviewType]}
            </p>
          </Col>
        </Row>
        <hr className="my-4" />
        <Row>
          <Col>
            <div
              className="mb-2"
              style={{ fontSize: "16px", color: "#202d63", fontWeight: "bold" }}
            >
              Features Overview
            </div>
            <Row>
              <FeatureOverview
                title={featureOverview[1].title}
                text={featureOverview[1].text}
              />
              <FeatureOverview
                title={featureOverview[2].title}
                text={featureOverview[2].text}
              />
            </Row>
            <Row>
              <FeatureOverview
                title={featureOverview[3].title}
                text={featureOverview[3].text}
              />
              <FeatureOverview
                title={featureOverview[4].title}
                text={featureOverview[4].text}
              />
            </Row>
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer style={{ padding: "16px 30px" }}>
        <Button
          onClick={handleCloseVIMerchandizingModal}
          id="closeVIMerchandizingModalFooter"
          variant="outline-primary"
          className="btn-cancel mr-3"
        >
          Close
        </Button>
        <Button
          variant="primary"
          onClick={() =>
            handleScheduleVIDemo(trackingSource, isFreeTrial, rep, utmParams)
          }
          id="scheduleDemo"
        >
          Schedule a Demo
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

VideoInterviewMerchandizingModal.propTypes = {
  showModal: bool,
  handleCloseVIMerchandizingModal: func,
  utmParams: object,
  isFreeTrial: bool,
  rep: object,
  interviewType: string,
};

export default VideoInterviewMerchandizingModal;
